//import { element } from "prop-types";
import { memo, useEffect } from "react";
import Dbfunctions from "../PouchDb/Pouchdb";
import {
  LOCAL_BANK_SET,
  LOCAL_CITY_SET,
  LOCAL_CONTENT_SET,
  LOCAL_MASTER_SET,
  LOCAL_NETWORK_MASTER_SET,
} from "../store/types";
import errorHandler from "./ErrorHandler";

const ExternalFiles = memo(({ getFilesSuccesFull, path, setError }) => {
  var config = window.global?.config;
  var eror = { message: "failed to load component" }
  // appconfig download method
  const getAppconfig = async () => {
    try { 
      //var apConfgurl=`${process.env.REACT_APP_REDIRECT_URL}/${process.env.REACT_APP_NAME}/Appconfig.json`;
	  const res = await fetch(process.env.PUBLIC_URL+`/Appconfig.json`);
      config = await res.json();
      window.global = { config };
      if (config?.version) {
        await checkUpdateVersion(config.version);
      }
      if (config?.dncanalytics) {
        loadDncanalytics(() => { });
      }
      if (config?.adobeanalytics) {
		loadAdobeanalytics(() => { });   
		//var adburl=`${process.env.REACT_APP_REDIRECT_URL}/${process.env.REACT_APP_NAME}/DncAdobeconfig.json`;
		const adoberes = await fetch(process.env.PUBLIC_URL+`/DncAdobeconfig.json`);
        var adobe_object = await adoberes.json();
        window.global = { ...window.global, adobe_object };
      }
      if (config?.applicationDown) {
        var root = document.getElementById("root");
        root.remove();
        var maintainanceEle = document.createElement("div");
        maintainanceEle.innerHTML = config?.downHtml;
        document.body.appendChild(maintainanceEle);
      }
      getFilesSuccesFull(config);
    }
    catch (e) {
      setError(eror)


    }
  };

//adobe analytics file download
  const loadAdobeanalytics = (callback) => {
    try {
      const existingScript1 = document.getElementById("adobeanalytics");
      if (!existingScript1) {
        const url =  config?.REACT_APP_ENV==="DEV" ?  config?.adobeurl : config?.prodAdobeurl ;
        const script1 = document.createElement("script");
        script1.type = "application/javascript";
        script1.src = url;
        script1.id = "adobeanalytics";
        script1.async = true;
        document.head.appendChild(script1);
        script1.onload = () => {
          if (callback) callback();
        };
      }
      if (existingScript1 && callback) callback();
    }
    catch (e) {

      setError(eror)


    }
  };
  //dnc analytics file download
  const loadDncanalytics = (callback) => {
    try {
      const existingScript = document.getElementById("dncanalytics");
      if (!existingScript) {
        const script = document.createElement("script");
        const dncanalyticsFile  = config?.REACT_APP_ENV==="DEV" ? "dncanalytics-uat.js" : "dncanalytics.js" ;
        script.src = `${path}/${process.env.REACT_APP_NAME}/${dncanalyticsFile}`;
        //script.src = `${path}/${process.env.REACT_APP_NAME}/dncanalytics.js`;
        script.id = "dncanalytics";
        script.type = "text/javascript";
        document.body.appendChild(script);
        script.onload = () => {
          if (callback) callback();
        };
      }
      if (existingScript && callback) callback();
    }
    catch (e) {

      setError(eror)


    }
  };
  const deleteLocalDBData = async () => {
    let masterLocal = localStorage.getItem("masterLocalVer");
    let contentLocal = localStorage.getItem("contentLocalVer");
    let cardTypeLocal = localStorage.getItem("cardTypeLocal");
    const currentPath = window.location.pathname.split("/");
    if (currentPath[2] && currentPath[2] !== cardTypeLocal) {
      await Dbfunctions.DeleteSate(LOCAL_CITY_SET);
    }

    if (config?.contentVer !== contentLocal || !contentLocal) {
      await Dbfunctions.DeleteSate(LOCAL_CONTENT_SET);
      await Dbfunctions.DeleteSate(LOCAL_NETWORK_MASTER_SET);
    }
    if (config?.masterVer !== masterLocal || !masterLocal) {
      await Dbfunctions.DeleteSate(LOCAL_MASTER_SET);
      await Dbfunctions.DeleteSate(LOCAL_BANK_SET);
      await Dbfunctions.DeleteSate(LOCAL_CITY_SET);
    }
    localStorage.setItem("masterLocalVer", config.masterVer)
    localStorage.setItem("contentLocalVer", config.contentVer)

  };
  const checkUpdateVersion = async (version) => {
    let localVersion = localStorage.getItem("versionNo");
    await deleteLocalDBData();

    if (localVersion && localVersion !== version) {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()s
        caches.keys().then((cacheNames) => {
          return Promise.all(
            cacheNames.map((cache) => {
              return caches.delete(cache); //Deleting the old cache (cache v1)
            })
          );
        });
      }
      localStorage.setItem("versionNo", version);
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
      // delete browser cache and hard reload
      window.location.reload(true);
    } else {
      localStorage.setItem("versionNo", version);
    }

  };

  useEffect(() => {
     if (!window.global?.config) {
      getAppconfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
});
export default errorHandler(ExternalFiles);
